module.exports = __webpack_public_path__ + "img/Withdrawal_Code_Fiat_auto.0e842a42.png";